module.exports = __webpack_public_path__ + "img/andre.008038ec.gif";